// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#app .tab-special-goods-ui-custom[data-v-46d74221] .bold .el-form-item__label {\n  font-weight: bold;\n  font-size: 14px;\n}\n", ""]);
// Exports
module.exports = exports;
